var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColteneLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_background",
    "data-name": "logo background",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1548.49,
    height: 1286.097,
    viewBox: "0 0 1548.49 1286.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coltene_logo_background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 1540.342,
    height: 1286.097,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 1540.344,
    height: 1286.097,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861",
    transform: "translate(0 0.373)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M232.253,421.778,89.587,720.806H277.02L419.555,421.778Z",
    transform: "translate(-16.596 -78.13)",
    fill: "#00b8f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M522.887,421.778,380.223,720.806H567.659L710.186,421.778Z",
    transform: "translate(-70.433 -78.13)",
    fill: "#5bcaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M813.569,421.778,670.908,720.806H858.341l142.536-299.028Z",
    transform: "translate(-124.28 -78.13)",
    fill: "#abe0f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M142.665,0,0,299.032H187.432L329.968,0Z",
    transform: "translate(0 0)",
    fill: "#00adee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M433.3,0,290.634,299.032H478.071L620.6,0Z",
    transform: "translate(-53.838 0)",
    fill: "#00adee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M723.986,0,581.322,299.032H768.759L911.294,0Z",
    transform: "translate(-107.685 0)",
    fill: "#00adee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColteneLogoBackground);
export default __webpack_public_path__ + "static/media/coltene_logo_background.4ac1027c29cbc60165f69ce4dc74f1c1.svg";
export { ForwardRef as ReactComponent };